// extracted by mini-css-extract-plugin
export default {"outline":"CustomLink_outline__4+anu","back":"CustomLink_back__vwReY"};